// src/components/PostItem.js
import React, { useState } from "react";
import "./Post.css"; // reuse your existing post styles
import { timeAgo } from "../utils/timeAgo";   // ✅ FIXED IMPORT

const PostItem = ({ post }) => {
  const [expanded, setExpanded] = useState(false);

  // ✅ Fix double-backend problem
  const getMediaUrl = (url) => {
    if (!url) return null;
    if (url.startsWith("http")) return url;
    return `${process.env.REACT_APP_API_URL}${url}`;
  };

  const toggleShowMore = () => setExpanded(!expanded);

  return (
    <div className="home-post">
      <div className="home-post-header">
        <img
          className="home-post-thumbnail"
          src={getMediaUrl(post.thumbnail) || "/images/default-thumbnail.jpg"}
          alt={post.username}
        />

        <div className="home-post-header-right">
          <div className="home-post-header-line">
            <div className="home-post-user-info">
              <span className="home-post-realname">
                {post.realname || post.username}
              </span>

              <span className="home-post-username">@{post.username}</span>

              {/* ⭐ NEW: timeAgo() formatting */}
              <span className="home-post-date">
                {timeAgo(post.createdAt)}
              </span>
            </div>
          </div>

          <p className="home-post-content-text">
            {expanded || post.content?.length < 200
              ? post.content
              : `${post.content?.slice(0, 200)}...`}
          </p>

          {post.content?.length > 200 && (
            <button className="home-show-more-btn" onClick={toggleShowMore}>
              {expanded ? "Show less" : "Show more"}
            </button>
          )}
        </div>
      </div>

      {/* ✅ Media */}
      {post.media_url && (
        <img
          className="home-post-media"
          src={getMediaUrl(post.media_url)}
          alt="Post media"
        />
      )}

      {post.gif && (
        <img className="home-post-media" src={post.gif} alt="GIF" />
      )}

      {/* Actions */}
      <div className="home-post-actions">
        <button className="action-btn" title="Reply">
          💬 {post.repliesCount || 0}
        </button>
        <button className="action-btn" title="Repost">
          🔁 {post.repostsCount || 0}
        </button>
        <button className="action-btn" title="Like">
          ❤ {post.likes || 0}
        </button>
      </div>
    </div>
  );
};

export default PostItem;
